"use client";

import { cn } from "@repo/ui";
import { useConsent } from "@shared/hooks/cookie-consent";
import { useTranslations } from "next-intl";

export function MarketingFooterCookieSettings({
	linkClassName,
}: {
	linkClassName: string;
}) {
	const t = useTranslations("cookies");
	const { open } = useConsent();

	return (
		<button
			type="button"
			onClick={() => open()}
			className={cn(
				linkClassName,
				"inline cursor-pointer border-none bg-transparent p-0 font-inherit",
			)}
		>
			{t("footerLink")}
		</button>
	);
}
